(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ingrediants-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sidebar        = document.querySelector(".sidebar");
  const overlay        = document.querySelector(".sidebar-overlay");
  const sidebarTitleEl = document.getElementById("sidebar-dynamic-title");
  const sidebarContentEl = document.getElementById("sidebar-dynamic-content");

  function openSidebarFromEl(el) {
    if (!el) return;
    const title = el.getAttribute("data-title") || "";
    const payloadEl = el.querySelector(".ingredient-card__sidebar-html");
    const html = payloadEl ? payloadEl.innerHTML : "";
    sidebarTitleEl.textContent = title;
    sidebarContentEl.innerHTML = html;
    sidebar.classList.add("open");
    overlay.classList.add("open");
  }

  // Desktop cards
  document.querySelectorAll(".ingredient-card").forEach((card) => {
    card.addEventListener("click", function () {
      openSidebarFromEl(this);
    });
  });

  // Mobile slides (click / tap slide to open)
  document.querySelectorAll(".ingredients-mobile-slide").forEach((slide) => {
    slide.addEventListener("click", function () {
      openSidebarFromEl(this);
    });
  });

  // Close actions
  document.querySelector(".sidebar-close").addEventListener("click", function () {
    sidebar.classList.remove("open");
    overlay.classList.remove("open");
  });

  overlay.addEventListener("click", function () {
    sidebar.classList.remove("open");
    overlay.classList.remove("open");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advanced-info-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".additional-info-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const section = this.closest(".advanced-info-section");
      const sidebar = section.querySelector(".sidebar");
      const overlay = section.querySelector(".sidebar-overlay");
      sidebar.classList.add("open");
      overlay.classList.add("open");
    });
  });

  document.querySelectorAll(".sidebar-close").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function () {
      const section = this.closest(".advanced-info-section");
      const sidebar = section.querySelector(".sidebar");
      const overlay = section.querySelector(".sidebar-overlay");
      sidebar.classList.remove("open");
      overlay.classList.remove("open");
    });
  });

  // Also close sidebar if overlay itself is clicked
  document.querySelectorAll(".sidebar-overlay").forEach((overlay) => {
    overlay.addEventListener("click", function () {
      const section = this.closest(".advanced-info-section");
      const sidebar = section.querySelector(".sidebar");
      sidebar.classList.remove("open");
      this.classList.remove("open");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sidebar = document.querySelector(".sidebar");
  const overlay = document.querySelector(".sidebar-overlay");
  const sidebarTitleEl = document.getElementById("sidebar-dynamic-title");
  const sidebarContentEl = document.getElementById("sidebar-dynamic-content");

  function openSidebarFromEl(el) {
    if (!el) return;
    const title = el.getAttribute("data-title") || "";
    const payloadEl = el.querySelector(".ingredient-card__sidebar-html");
    const html = payloadEl ? payloadEl.innerHTML : "";
    sidebarTitleEl.textContent = title;
    sidebarContentEl.innerHTML = html;
    sidebar.classList.add("open");
    overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  // Click on ingredient items
  document.querySelectorAll(".ingredient-list-item").forEach((item) => {
    item.addEventListener("click", function () {
      openSidebarFromEl(this);
    });
  });

  // Close sidebar
  document.querySelector(".sidebar-close").addEventListener("click", function () {
    sidebar.classList.remove("open");
    overlay.classList.remove("open");
    document.body.style.overflow = "auto";
  });

  overlay.addEventListener("click", function () {
    sidebar.classList.remove("open");
    overlay.classList.remove("open");
    document.body.style.overflow = "auto";
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-with-video-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll("[data-tab-button]");
    const tabPanels = document.querySelectorAll("[data-tab-panel]");
    const videos = document.querySelectorAll("[data-tab-video]");

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = btn.dataset.index;

        tabButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        tabPanels.forEach((panel) => {
          panel.classList.toggle("active", panel.dataset.index === index);
        });

        videos.forEach((video) => {
          const isActive = video.dataset.index === index;
          video.classList.toggle("active", isActive);

          const videoElement = video.querySelector('video');
          if (videoElement) {
            videoElement.pause();
            videoElement.currentTime = 0;
            if (isActive) {
              videoElement.play();
            }
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-with-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll("[data-tab-button]");
    const tabPanels = document.querySelectorAll("[data-tab-panel]");
    const videos = document.querySelectorAll("[data-tab-video]");

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = btn.dataset.index;

        tabButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        tabPanels.forEach((panel) => {
          panel.classList.toggle("active", panel.dataset.index === index);
        });

        videos.forEach((video) => {
          const isActive = video.dataset.index === index;
          video.classList.toggle("active", isActive);

          const videoElement = video.querySelector('video');
          if (videoElement) {
            videoElement.pause();
            videoElement.currentTime = 0;
            if (isActive) {
              videoElement.play();
            }
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-blog-article"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const reviewedBtn = document.querySelector(".vet-reviewed .reviewed-btn");
  const sidebar = document.querySelector(".vet-reviewed-section .sidebar");
  const overlay = document.querySelector(".vet-reviewed-section .sidebar-overlay");
  const closeBtn = document.querySelector(".vet-reviewed-section .sidebar-close");

  if (reviewedBtn && sidebar && overlay) {
    reviewedBtn.addEventListener("click", function () {
      sidebar.classList.add("open");
      overlay.classList.add("open");
    });

    closeBtn.addEventListener("click", function () {
      sidebar.classList.remove("open");
      overlay.classList.remove("open");
    });

    overlay.addEventListener("click", function () {
      sidebar.classList.remove("open");
      overlay.classList.remove("open");
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
